// Record forms keep their original location/LSD strings for reports and exports.
import { sameSiteLocation } from './sites';

export const recordSite = (record, sites = [], job = false) => {
  const name = record[job ? 'customer_location' : 'location'] || '';
  const lsd = record[job ? 'customer_lsd' : 'lsd'] || '';
  const saved = sites.find((s) => sameSiteLocation(s, { name, lsd, address: record.site_details?.address || '' }));
  return { province: '', address: '', components: {}, ...(record.site_details ?? saved ?? {}), name, lsd };
};

export const recordSitePatch = (site, job = false) => ({
  [job ? 'customer_location' : 'location']: site.name || '',
  [job ? 'customer_lsd' : 'lsd']: site.lsd || '',
  site_details: { ...site },
});

export const parseLsd = (layout, lsd = '') => {
  let match;
  if (layout?.name === 'ALBERTA & SASK LSD') {
    match = lsd.trim().match(/^(\d{1,2})-(\d{1,2})-(\d{1,3})-(\d{1,2})W(\d)$/i);
    if (match) return Object.fromEntries(['LSD', 'SECTION', 'TOWNSHIP', 'RANGE', 'MERIDIAN'].map((key, i) => [key, String(Number(match[i + 1]))]));
  }
  if (layout?.name === 'BC LSD') {
    match = lsd.trim().match(/^([a-d])-(\d{1,3})-([a-l])\/(\d{1,3})-([a-p])-(\d{1,2})$/i);
    if (match) return Object.fromEntries(['QUARTER', 'CENTRIZONE', 'ZONE BLOCK', 'MAP UNIT', 'MAP UNIT SUB', 'MAP SHEET'].map((key, i) => [key, /^\d+$/.test(match[i + 1]) ? String(Number(match[i + 1])) : match[i + 1].toUpperCase()]));
  }
  return {};
};

export const siteComponents = (site, layout) => Object.values(site.components || {}).some(Boolean)
  ? site.components : parseLsd(layout, site.lsd);

export const siteError = (site, layout) => {
  if (!layout) return '';
  const components = siteComponents(site, layout);
  if (!site.lsd && !Object.values(components).some(Boolean)) return '';
  const invalid = layout.fields.find((f) => !f.options.includes(String(components[f.label] || '')));
  return invalid ? `Select a valid ${invalid.label.toLowerCase()} for the LSD` : '';
};